import { AccountTypes } from "features/Accounts/types";

export const hasGroupTemplateSettingsAccess = (accountTypeId: number) =>
  accountTypeId === AccountTypes.BSI || accountTypeId === AccountTypes.ChannelPartner;
